import * as React from 'react';
import {useSelector} from 'react-redux';
import {useEffect} from 'react';
import {Link} from 'react-router-dom';

const ProgrammeScreen = ({history, language, t}) => {

    const userLogin = useSelector((state) => state.userLogin);
    const {userInfo} = userLogin;

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [userInfo, history]);

/*    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);*/

    return (
        <div className='d-flex align-baseline mb-4 justify-content-around'>
            <div className='align-self-center mr-auto'>
                <Link to='/commercials' className='btn btn-info m-0 p-2'>Vissza</Link>
            </div>
            <h2 className='m-auto text-center'>
                Műsorfüzet adatok
            </h2>
            <div className='align-self-center ml-auto invisible'>
                <div className='btn btn-danger m-0 p-2' /*onClick={() => setShow(true)}*/>Vissza</div>
            </div>
        </div>
    );
};

export default ProgrammeScreen;